import { type ReactElement } from 'react'
import * as S from './testimonial-links.styled'
import { Swiper } from '../swiper/swiper'
import { Carousel } from '../carousel/carousel'
import { testimonialsData } from './testimonials-data'

export function TestimonialLinks (): ReactElement {
  const testimonialLinks = testimonialsData.map(({ name, thumbnail, videoId }) => <S.TestimonialLink to={`https://www.youtube.com/watch?v=${videoId}`} target="_blank" rel="noreferrer noopener" draggable={false}>
    <img src={thumbnail} alt={name} draggable={false} />
  </S.TestimonialLink>)

  return <>
    <S.SwiperContainer>
      <Swiper className="swiper" fade showArrows>
        {testimonialLinks}
      </Swiper>
    </S.SwiperContainer>
    <S.CarouselContainer>
      <Carousel className="carousel" inactiveButtonColor="#084F43" offset={24} showDots>
        {testimonialLinks}
      </Carousel>
      <S.CarouselButton>Peça já o seu</S.CarouselButton>
    </S.CarouselContainer>
  </>
}
